import { Alert, Button, Modal, Tabs } from "@toddle-edu/ds-web";
import React, { memo, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import classes from "./WarningModal.scss";
import { getCurrentTabData, getTabOptions } from "./modules/utils";
import _ from "lodash";
import { TAB_TYPES, getFeedListColumns } from "./modules/constants";
import FeedListv2 from "AppComponents/FeedListv2";
import getCustomComponent from "./components/getCustomComponent";

const TEST_ID_PREFIX = "transcriptsV3-gradeLevels-bulkCopyWarning";

const styles = {
  bodyStyles: {
    minHeight: 0,
    gap: 16,
    width: "100%",
    padding: 0,
  },
  alertStyles: {
    margin: "0 16px -4px",
  },
};

const WarningModal = ({ onClose, data }) => {
  const { t } = useTranslation();
  const { skipped, applied } = data || {};

  const tabOptions = useMemo(() => getTabOptions({ t, skipped, applied }), [
    t,
    skipped,
    applied,
  ]);

  const [selectedTab, setSelectedTab] = useState(
    _.get(tabOptions, "[0].value", "")
  );

  const columnList = useMemo(() => {
    const columns = getFeedListColumns(t);
    return columns[selectedTab];
  }, [selectedTab, t]);

  const feedData = useMemo(
    () => getCurrentTabData({ selectedTab, skipped, applied, t }),
    [skipped, applied, selectedTab, t]
  );

  return (
    <Modal isOpen onClose={onClose} width={848} height={700}>
      <Modal.Header
        title={t("transcript:review_configurations_applied_for_other_students")}
        testId={TEST_ID_PREFIX}
        hasSeparator
      />

      <Modal.Body style={styles.bodyStyles}>
        <div className={classes.tabsWrapper}>
          <Tabs
            options={tabOptions}
            value={selectedTab}
            onChange={setSelectedTab}
            name="bulkCopy-warningInfo"
            testId={TEST_ID_PREFIX}
          />
        </div>

        {selectedTab === TAB_TYPES.SKIPPED ? (
          <Alert
            type="error"
            message={t("transcript:bulk_copy_skipped_tab_warning_message")}
            style={styles.alertStyles}
          />
        ) : null}

        <div className={classes.feedListWrapper}>
          <FeedListv2
            columnList={columnList}
            feedData={feedData}
            isData={!_.isEmpty(feedData)}
            isLoading={false}
            testId={TEST_ID_PREFIX}
            enableStickyHeader
            getCustomComponent={getCustomComponent}
            showBorder
            headerTheme="subtle"
            showRowBackgroundOnHover={false}
          />
        </div>
      </Modal.Body>

      <Modal.Footer hasSeparator>
        <div className={classes.footer}>
          <Button
            variant="progressive"
            testId={`${TEST_ID_PREFIX}-iUnderstand`}
            onClick={onClose}
          >
            {t("common:i_understand")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default memo(WarningModal);
